/*
POPUPS
 */
export const ADD_PROMO_OR_INVITE_CODE = 'AddPromoOrInviteCode';
export const CALCULATOR_CURRENCIES_POPUP = 'CalculatorCurrenciesPopup';
export const CVV_POPUP = 'CvvPopup';
export const CANCEL_OR_REISSUE_CARD_POPUP = 'CancelOrReissueCardPopup';
export const CHANGE_LINKED_ACC_POPUP = 'ChangeLinkedAccPopup';
export const EMAIL_POPUP = 'EmailPopup';
export const ERROR_DETAILS_POPUP = 'ErrorDetailsPopup';
export const FEE_TEXT_POPUP = 'FeeTextPopup';
export const FIELD_ERROR_POPUP = 'FieldErrorPopup';
export const PAY_PRECHECK_POPUP = 'PayPrecheckPopup';
export const REQUEST_CREATE_PRECHECK_POPUP = 'RequestPrecheckPopup';
export const RENAME_POPUP = 'RenamePopup';
export const REQUEST_MORE_POPUP = 'RequestMorePopup';
export const REISSUE_CARD_POPUP = 'ReissueCardPopup';
export const SEND_MORE_POPUP = 'SendMorePopup';
export const SUPPORT_POPUP = 'SupportPopup';
export const TEXT_POPUP = 'TextPopup';
export const TOPUP_CARD_RESTRICTION_POPUP = 'TopUpCardRestriction';
export const TOPUP_CVV_POPUP = 'TopUpCvvPopup';

/* PUBLIC WEB POPUPS */
export const QR_POPUP = 'qr';

/*
MODALS
 */
export const LEAN_MODAL = 'LeanModal';
export const FRAUD_BLOCK_INFO_MODAL = 'FraudBlockInfoModal';
export const FRAUD_BLOCK_DISCLAIMER_MODAL = 'FraudBlockDisclaimer';
export const SEND_CHEQUE_MODAL = 'SendCheque';
export const REQUEST_DETAILS_MODAL = 'RequestDetails';
export const TRANSFER_STATUS_SCREEN_MODAL = 'TransferStatusScreen';

/*
SCREENS
 */
export const LEAN_WAITING_SCREEN = 'LeanWaitingScreen';
export const LEAN_SDK_SCREEN = 'LeanSDKScreen';
export const LEAN_SELECT_BANK_SCREEN = 'LeanSelectBankScreen';
export const KYC_GUIDE_SCREEN = 'KycGuidScreen';
export const KYC_INTRO_SCREEN = 'KycIntroScreen';
export const KYC_BIOMETRIC_DISCLAIMER_SCREEN = 'KycBiometricDisclaimerScreen';
export const KYC_FAILED_SCREEN = 'KycFailedScreen';
export const KYC_VERIFYING_SCREEN = 'KycVerifyingScreen';
export const KYC_FAILED_VERIFYING_SCREEN = 'KycFailedVerifyingScreen';
export const KYC_FIELDS_SCREEN = 'KycFieldsScreen';
export const KYC_INFO_SCREEN = 'KycInfoScreen';
export const ONFIDO_DOCUMENTS_SCREEN = 'onfidoDocumentsScreen';
export const ONFIDO_DOCUMENT_EXPLANATION_SCREEN = 'onfidoDocumentExplanationScreen';

export const LULU_KYC_SDK = 'LuluKycSDK';
export const ONFIDO_SDK = 'onfidoSDK';
export const MOTION_ONFIDO_SDK = 'motionOnfidoSDK';
export const SUMSUB_SDK = 'onfidoSDKScreen';

export const FRAUD_INTRO_SUM_VERIFICATION = 'fraudIntroSumVerification';
export const FRAUD_ENTER_SUM_VERIFICATION = 'fraudEnterSumVerification';
export const FRAUD_RESULT_VERIFICATION = 'fraudResultVerification';

export const FRAUD_SOURCE_OF_INCOME_INTRO = 'fraudSourceOfIncomeIntro';

export const FRAUD_SOURCE_OF_INCOME_INSTRUCTIONS = 'fraudSourceOfIncomeInstructions';

export const FRAUD_FAILED_SUM_VERIFICATION = 'fraudFailedSumPayment';

export const FRAUD_INCORRECT_AMOUNT = 'fraudIncorrectAmount';

export const FRAUD_SUM_TRY_AGAIN = 'fraudSumTryAgain';
